import _implicitStylesheets from "./pdfViewerToolbar.css";

import _implicitScopedStylesheets from "./pdfViewerToolbar.scoped.css?scoped=true";

import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {h: api_element} = $api;
  return [api_element("div", {
    classMap: {
      "zp": true,
      "toolbarWrapper": true
    },
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 0
  }, [])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-pdfViewerToolbar_pdfViewerToolbar"
